import React from "react";

const TermsAndConditions = () => {
    return (
        <div style={styles.container}>
            <h1 style={styles.title}>PRIVACY POLICY</h1>

            <section>
                <h2 style={styles.h2}>1. Introduction</h2>
                <p style={styles.p}>
                    We value your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, and safeguard your data.
                </p>
            </section>

            <section>
                <h2 style={styles.h2}>2. Information We Collect</h2>
                <p style={styles.p}>We may collect the following details:</p>
                <ul style={styles.ul}>
                    <li>Name, contact number, email address</li>
                    <li>Birth star (Nakshatra), pooja details</li>
                    <li> Payment-related information (processed securely via payment gateway) </li>

                </ul>
            </section>

            <section>
                <h2 style={styles.h2}>3. Use of Information</h2>
                <p style={styles.p}>Your information is used to:</p>
                <ul style={styles.ul}>
                    <li>Process pooja bookings and payments</li>
                    <li> Send confirmations and updates</li>
                    <li>  Improve our services</li>

                </ul>
            </section>

            <section>
                <h2 style={styles.h2}>4. Payment Security</h2>
                <ul style={styles.ul}>
                    <li> All transactions are processed through secure third-party payment gateways</li>
                    <li>  We do not store your debit/credit card details</li>
                    <li>  Payment data is encrypted using industry-standard security measures</li>

                </ul>
            </section>

            <section>
                <h2 style={styles.h2}>5. Data Sharing</h2>
                <p style={styles.p}>We do not sell or share your personal information with third parties except:</p>
                <ul style={styles.ul}>
                    <li>  Payment gateway providers for transaction processing</li>
                    <li>  Legal authorities if required by law</li>

                </ul>
            </section>

            <section>
                <h2 style={styles.h2}>6. Data Retention</h2>
                <p style={styles.p}>Your data is retained only as long as necessary for service delivery and compliance with legal requirements.</p>
            </section>

            <section>
                <h2 style={styles.h2}>7. Cookies and Tracking</h2>
                <p style={styles.p}>Our website may use cookies to enhance user experience and improve functionality.</p>

            </section>

            <section>
                <h2 style={styles.h2}>8. User Rights</h2>
                <p style={styles.p}>You have the right to:</p>
                <ul style={styles.ul}>
                    <li>  Access your personal data</li>
                    <li>  Request correction or deletion</li>
                    <li>  Withdraw consent where applicable</li>

                </ul>
            </section>

            <section>
                <h2 style={styles.h2}>9. Security Measures</h2>
                <p style={styles.p}>
                    We implement appropriate technical and organizational measures to protect your data from unauthorized access.
                </p>
            </section>

            <section>
                <h2 style={styles.h2}>10. Third-Party Links</h2>
                <p style={styles.p}>
                    Our website may contain links to external sites. We are not responsible for their privacy practices.
                </p>
            </section>

            <section>
                <h2 style={styles.h2}>11. Changes to Privacy Policy</h2>
                <p style={styles.p}>
                    We may update this Privacy Policy from time to time. Changes will be posted on this page.
                </p>
            </section>

            <section>
                <h2 style={styles.h2}>12. Contact Us</h2>
                <p style={styles.p}>
                    <strong>The Executive Officer,</strong>
                    <br />
                    Sreekanteswara Temple <br />Ward No 5, EMS Stadium Building, <br />SK Temple Rd, Near, Tazhekkod, <br />Kozhikode, Kerala 673001	
                    <br />
                    Phone: 
                    <br />
                    Email: 
                </p>
            </section>
        </div>
    );
};

const styles = {
    container: {
        maxWidth: "900px",
        margin: "0 auto",
        marginTop: "120px",
        padding: "50px",
        fontFamily: "Arial, sans-serif",
        lineHeight: "1.6",
        backgroundColor: "white",

    },
    title: {
        textAlign: "center",
        marginBottom: "30px",
        fontSize: "30px",
        fontWeight: "600",
        borderBottom: "2px solid black",
    },
    h2: {
        color: "black",
        fontSize: "24px",
        marginTop: "20px",
        fontWeight: "600",
        marginTop: "40px",
    },
    p: {
        fontSize: "15px",
        lineHeight: "1.6",
    },
    ul: {
        fontSize: "15px",
        paddingLeft: "33px",
        color: "black",
        listStyleType: "disc",
    },
};

export default TermsAndConditions;